<!--  section  -->
<section class="parallax-section single-par" data-scrollax-parent="true">
    <div class="bg par-elem " style="background-image: url('../../assets/images/bg/5.jpg'); translate:'30%'"></div>
    <div class="overlay op7"></div>
    <div class="container">
        <div class="section-title center-align big-title">
            <h2><span>Our Product</span></h2>
            <span class="section-separator"></span>
            <h4> Click on the category of your choice to view the Listings. </h4>
        </div>
    </div>
    <div class="header-sec-link">
        <a href="javascript:void(0)" class="custom-scroll-link"><i class="fal fa-angle-double-down"></i></a>
    </div>
</section>
<!--  section  end-->
<section class="gray-bg small-padding no-top-padding-sec" id="sec1">
    <div class="container">
        <div class="breadcrumbs inline-breadcrumbs fl-wrap block-breadcrumbs">
            <a routerLinkActive="active" routerLink="">Home</a><span>Product List</span>
        </div>
        <div class="mob-nav-content-btn color2-bg show-list-wrap-search ntm fl-wrap" [ngClass]="hideshow ? 'slsw_vis' : ''" (click)="toggle()"><i class="fal fa-filter"></i> Filters</div>
        <div class="fl-wrap">
            <div class="row">
                <div class="col-md-4">
                    <div class=" fl-wrap lws_mobile" [ngClass]="hideshow ? 'd-block' : ''">
                        <!--box-widget-item -->
                        <app-filters [productList]="productList"></app-filters> 
                        <!--box-widget-item end -->
                                                
                        <!--box-widget-item -->
                        <div class="box-widget-item fl-wrap block_box mt-3">
                            <div class="box-widget-item-header">
                                <h3>Premium Advertiser</h3>
                            </div>
                            <div class="box-widget fl-wrap">
                                <div class="box-widget-content">
                                    <!-- Ads listing-item-grid  -->
                                    <div class="listing-item-grid" *ngFor="let ads of businessAds;">
                                        <div class="bg" [ngStyle]="{'background-image': ' url('+serverImgUrl +'adsImages/'+ ads.adsImageURL+')'}"></div>
                                        <div class="d-gr-sec"></div>
                                        <div class="listing-counter color2-bg">
                                            <span><i class="fas fa-map-marker-alt"></i> {{ads.businessCity}} | {{ads.adsDistrict}}, </span>{{ads.adsState}} | {{ads.adsCountry}}
                                            <a href="{{ads.facebookURL}}" class="ms-1 text-white" target="_blank" title="Facebook"><i class="fab fa-facebook"></i></a>
                                            <a href="{{ads.twitterURL}}" class="ms-1 text-white" target="_blank" title="Twitter"><i class="fab fa-twitter"></i></a>
                                            <a href="{{ads.instagramURL}}" class="ms-1 text-white" target="_blank" title="Instagram"><i class="fab fa-instagram"></i></a>
                                        </div>
                                        <div class="listing-item-grid_title">
                                            <h3><a routerLinkActive="active" [routerLink]="['/business-details', ads.businessName | businessSlug]" title="{{ads.adsTitle}}"> {{ads.adsTitle | shorten: 50: '...'}} </a></h3>
                                            <p>{{ads.businessName | shorten: 30: '...'}}</p>
                                            <p class="hide">{{ads.adsDetails | shorten: 100: '...'}}</p>
                                        </div>
                                    </div>
                                    <!-- Ads listing-item-grid end  -->
                                </div>
                            </div>
                        </div>
                        <!--box-widget-item end -->

                        <!--box-widget-item -->
                        <div class="box-widget-item fl-wrap block_box hide">
                            <div class="box-widget-item-header">
                                <h3>Business Categories</h3>
                            </div>
                            <div class="box-widget fl-wrap">
                                <div class="box-widget-content scrollbox">
                                    <ul class="cat-item no-list-style">
                                        <app-categories-list></app-categories-list>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <!--box-widget-item end -->
                    </div>
                </div>
                <div class="col-md-8">
                    <app-product-list #productList></app-product-list>
                </div>
            </div>
        </div>
    </div>
</section>
<!--section end-->
<div class="limit-box fl-wrap"></div>
<!-- <app-cart></app-cart> -->